var DeliveryTimeUI = function (globalVars, now, $) {
	//Wenn diese Variable wie allen anderen in initializeVariables gezogen wird, wird das Datum immer zurückgesetzt.
	//Nebenläufigkeitsprobleme?
	var ptProdDurationAdditionalAll = [];

	/*Führt eine Funktion nur ein mal aus.*/
	var uniqueCalls = {};
	var uniqueCall = function(name,fn,elem){
		var nrOfCalls = uniqueCalls[name] || 0;
		if(nrOfCalls == 0)
		{
			uniqueCalls[name] = 1;
			fn(elem);
		}
	}

	var checkActualDayIsHoliday = function () {
		if ($.inArray(moment(now).format('DD-MM-YYYY'), globalVars.holiday) == -1) {
			return false;
		} else {
			return true;
		}
	}

	var calcDeadlineForView = function (deadline) {
		var ptDeadlineForView = deadline;
		var calcUTCCorrection = globalVars.calcUTCCorrection;
		if (!isNaN(calcUTCCorrection)) {
			if (deadline != '') {
				if (calcUTCCorrection < 0) {
					calcUTCCorrection = calcUTCCorrection * -1;
					ptDeadlineForView = moment(ptDeadlineForView, 'HH:mm').subtract(calcUTCCorrection, 'hours');
					ptDeadlineForView = moment(ptDeadlineForView).format('HH:mm');
					calcUTCCorrection = calcUTCCorrection * -1;
				} else if (calcUTCCorrection > 0) {
					ptDeadlineForView = moment(deadline, 'HH:mm').add(calcUTCCorrection, 'hours');
					ptDeadlineForView = moment(deadline).format('HH:mm');
				}
			}
		}
		return ptDeadlineForView;
	}

	var productionTimeMsgOnLoad = function (deadline) {
		var ptDeadlineForView = calcDeadlineForView(deadline);
		if (!checkActualDayIsHoliday()) {
			if (typeof deadline != 'undefined' && deadline != '') {
				$('.dynamicProductDepvariation, .dynamicProductDepvariationTwo').remove();
				var productionTimeSelector = $('.select_dep_variations_with_links_without_data_right[name*="Y_"], .select_dep_variations[name*="Y_"]').parent().siblings(":last");
				if (now.format('HH:mm') <= deadline) {
					$(productionTimeSelector).after('<p class="product_depvariation_clear dynamicProductDepvariation">' + globalVars.calcDeadlineOKTxt01 + ' <b>' + ptDeadlineForView + '</b> ' + globalVars.calcDeadlineOKTxt02 + '</p><p class="product_depvariation_clear dynamicProductDepvariationTwo"></p>');
				} else {
					$(productionTimeSelector).after('<p class="product_depvariation_clear dynamicProductDepvariation">' + globalVars.calcDeadlinePassedTxt01 + ' <b>' + ptDeadlineForView + '</b> ' + globalVars.calcDeadlinePassedTxt02 + '</p><p class="product_depvariation_clear dynamicProductDepvariationTwo"></p>');
				}
			}
		} else {
			$('.dynamicProductDepvariation, .dynamicProductDepvariationTwo').remove();
			var productionTimeSelector = $('.select_dep_variations_with_links_without_data_right[name*="Y_"], .select_dep_variations[name*="Y_"]').parent().siblings(":last");
			$(productionTimeSelector).after('<p class="product_depvariation_clear dynamicProductDepvariation">' + globalVars.holidayTxt + '</p><p class="product_depvariation_clear dynamicProductDepvariationTwo"></p>');
		}
	}

	var moveProductionTimeBox = function () {
		$('.select_dep_variations_with_links_without_data_right[name*="Y_"]').parent().parent().parent().prependTo('#ptMoveToBasicConfiguration');
		$('.select_dep_variations[name*="Y_"]').parent().parent().parent().prependTo('#ptMoveToBasicConfiguration');
	}

	var infotxtResponseRequired = function () {
		$('.select_dep_variations_with_links_without_data_right[data-prnumber="ZXXXXXXTT01"], .select_dep_variations_with_links_without_data_right[data-prnumber="ZXXXXXXPP01"]').parent().parent().append('<p class="product_depvariation_clear productDepvariationClear">' + globalVars.calcNotificationTxt01 + '</p>');
	}

	var infotxtShorterEdge = function () {
		var prNumber = $('.select_dep_variations_with_links_without_data_right[data-prnumber*="Z"]').attr('data-prnumber');
		if (typeof prNumber != 'undefined') {
			var categoryIndicator = $('.select_dep_variations_with_links_without_data_right[data-prnumber*="Z"]').attr('data-prnumber').substring(3, 0);

			// Nur fuer Kataloge und Broschueren
			if (categoryIndicator == 'ZBR' || categoryIndicator == 'ZKT') {
				$('.select_dep_variations_with_links_without_data_right[data-prnumber$="6G"], .select_dep_variations_with_links_without_data_right[data-prnumber$="6M"]').parent().parent().append('<p class="product_depvariation_clear productDepvariationClear">' + globalVars.calcNotificationTxt02 + '</p>');
			}
		}
	}

	var removeSecondDiscountMinusSign = function () {
		if (typeof $('.product_depvariation_aufpreis').html() !== 'undefined') {
			$.each($(document), function (k) {
				var aufschlagTxt = [];
				aufschlagTxt = $('.product_depvariation_aufpreis').text().replace(/ \-/g, ' ').split(/#/);
				aufschlagTxt.pop();
				aufschlagTxt.forEach((aufschlag,i) => {
					$('.product_depvariation_aufpreis:eq(' + i + ')').html('<b>' + aufschlag + '</b>');
				});
			});
		}
	}

	var splitProductionTimeVS4 = function (element, split) {
		if ($(element).text() == '') {
			split = [];
		} else {
			split = $(element).text().split(';');
		}
		return split; 
	}

	var filterPtSplit = function (i, split, chars, numbers, numberOfDays) {
		chars[i] = split[0].replace(/[0-9]/g, '');
		numberOfDays = split[1];
		numbers[i] = split[0].replace(/\D/g, '');
		return { chars: chars[i], numberOfDays: numberOfDays, numbers: numbers[i] };
	}

	var setAndUpdateDeadline = function (split, deadline) {
		if (typeof (split[1]) === 'undefined') {
			split[1] = '';
		} else {
			deadline = split[1];
		}
		return { split: split[1], deadline: deadline };
	}

	var uniqueChar = function (chars) {
		$.unique(chars);
		chars.sort();
		return chars;
	}

	var uniqueNumbers = function (numbers) {
		$.unique(numbers);
		numbers.sort();
		for (var j = numbers.length; j > 1; j--) {
			numbers.pop();
		}
		return numbers;
	}

	var addExtraProductTime = function (prodDurationAdditionalAll) {
		var duration = 0;
		for (var i = 0; i < prodDurationAdditionalAll.length; i++) {
			duration += prodDurationAdditionalAll[i];
		}
		return duration;
	}

	var productionTimeMsgAjax = function (deadline) {
		var ptDeadlineForView = calcDeadlineForView(deadline);
		if (!checkActualDayIsHoliday()) {
			if (typeof deadline != 'undefined' && deadline != '') {
				$('.dynamicProductDepvariation, .dynamicProductDepvariationTwo').remove();
				var finalElement = $('#ptMoveToBasicConfiguration').children().children().children().siblings(":last").next();
				if (now.format('HH:mm') <= deadline) {
					$(finalElement).after('<p class="product_depvariation_clear dynamicProductDepvariation">' + globalVars.calcDeadlineOKTxt01 + ' <b>' + ptDeadlineForView + '</b> ' + globalVars.calcDeadlineOKTxt02 + '</p><p class="product_depvariation_clear dynamicProductDepvariationTwo"></p>');
				} else {
					$(finalElement).after('<p class="product_depvariation_clear dynamicProductDepvariation">' + globalVars.calcDeadlinePassedTxt01 + ' <b>' + ptDeadlineForView + '</b> ' + globalVars.calcDeadlinePassedTxt02 + '</p><p class="product_depvariation_clear dynamicProductDepvariationTwo"></p>');
				}
			}
		} else {
			$('.dynamicProductDepvariation, .dynamicProductDepvariationTwo').remove();
			var finalElement = $('#ptMoveToBasicConfiguration').children().children().children().siblings(":last").next();
			$(finalElement).after('<p class="product_depvariation_clear dynamicProductDepvariation">' + globalVars.holidayTxt + '</p><p class="product_depvariation_clear dynamicProductDepvariationTwo"></p>');
		}
	}

	var checkForSamePrNumber = function (element, numbers, prevPrNumber, prodDurationAdditionalAll) {
		var currentPrNumber = $(element).parent().parent().siblings('.productDepvariationListbox').find('select').attr('data-prnumber');
		if (typeof prevPrNumber == 'undefined' || prevPrNumber == false) {
			prevPrNumber = currentPrNumber;
			showProductTimeCalculation(element, numbers);
			prodDurationAdditionalAll[prodDurationAdditionalAll.length] = parseInt(numbers);
		} else {
			if (prevPrNumber == currentPrNumber) {
				// Zeigt bei einem identischen Element die Arbeitstage nicht an und berechnet diese auch nicht
				$(element).html('');
			} else {
				prevPrNumber = currentPrNumber;
				showProductTimeCalculation(element, numbers);
				prodDurationAdditionalAll[prodDurationAdditionalAll.length] = parseInt(numbers);
			}
		}
		return prevPrNumber;
	}

	var showProductTimeCalculation = function (element, numbers) {
		var ptNr = parseInt(numbers),
			ptTxt;
		if (ptNr == 1) {
			ptTxt = '+' + numbers + ' ' + globalVars.calcWT1;
		} else {
			ptTxt = '+' + numbers + ' ' + globalVars.calcWT2;
		}
		if (globalVars.subShopId == '32-aa' && ptNr >= 5) {
			ptTxt = '+' + numbers + ' ' + globalVars.calcWT3;
		}
		$(element).html(ptTxt);
	}

	return {
		moveBoxes: function () {
			if ($('.ProductionTimeCalculation').html() != '' && $('.ProductionTimeCalculation').html() != null) {
				moveProductionTimeBox();
				//uniqueCall ist notwendig, da diese Funktion bei mehrfachen Aufrufen die Hinweisboxen mehrfach ausgeben
				uniqueCall('infotxtResponseRequired',infotxtResponseRequired);
				uniqueCall('infotxtShorterEdge',infotxtShorterEdge);
				removeSecondDiscountMinusSign();
			}
		},
		initializeVariables: function () {
			var deadline = [], split = [], filterSplit, chars = [], numberOfDays, numbers = [], prodDurationAlternative = 0,
				prodDurationBasic = 0, prodTimeAndWeekends = 0, prevPrNumber = false;

			if ($('.ProductionTimeCalculation').html() != '' && $('.ProductionTimeCalculation').html() != null) {
				$.each($('.ProductionTimeCalculation'), function (i) {
					split = splitProductionTimeVS4(this, split);
					if (split.length > 0) {
						filterSplit = filterPtSplit(i, split, chars, numbers, numberOfDays);
						chars[i] = filterSplit.chars;
						numberOfDays = filterSplit.numberOfDays;
						numbers[i] = filterSplit.numbers;
						var newDeadlines = setAndUpdateDeadline(split, deadline);
						split[1] = newDeadlines.split;
						deadline = newDeadlines.deadline;

						switch (chars[i]) {
							case 'TE':
							case 'TB':
							case 'T':
								prodDurationAlternative = parseInt(numbers[i]);
								if (typeof deadline != 'undefined' && moment(now).format('E') < 6) {
									productionTimeMsgAjax(deadline);
								}
								break;
							case 'P':
								prodDurationBasic = parseInt(numbers[i]);
								if (typeof deadline != 'undefined' && moment(now).format('E') < 6) {
									productionTimeMsgOnLoad(deadline);
								}
								break;
							case 'Z':
								$(this).css('display', 'block');
								if (globalVars.pageName == 'product') {
									$(this).parent().parent().css('display', 'block');
								}
								prevPrNumber = checkForSamePrNumber(this, numbers[i], prevPrNumber, ptProdDurationAdditionalAll);
								break;
							default:
								break;
						}
					}
				});
				chars = uniqueChar(chars);
				numbers = uniqueNumbers(numbers);
				var additionalDays = addExtraProductTime(ptProdDurationAdditionalAll);

				return {
					prodTypes: chars,
					prodDurationAlternative: prodDurationAlternative,
					prodDurationBasic: prodDurationBasic,
					todaysDeadline: deadline,
					additionalDays: additionalDays
				}
			}
		},
		updateDates: function (deliveryDate) {
			var readyDate = deliveryDate.locale(globalVars.calcLanguageCode).format(globalVars.calcDateFormat);
			$('.production_date span:eq(1)').html(readyDate);
			$('.production_date').removeClass('globalDisplayNone');
			$('.table_product_append').fadeIn(1000);
			$('input.ptDateConfirmPage').val(readyDate);
		},
		updateVersandartView : function()
		{
			//aktualisiert versandartText "Bei Standardversand", bzw. "Bei Expressversand"
			$('.jsTxtMitVersandart').html('(' + globalVars.expressversandText + ')');
			
			//versteckt die Versandkostenzeile
			$('.boxContentSummaryRightShipping').hide();
		}
	}
}

export default DeliveryTimeUI;


// WEBPACK FOOTER //
// ./src/scripts/op/productionTimeCalculation/DeliveryTimeUI.es6.js